var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionIcon = function SvgQuestionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#6777FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E5FF",
    d: "M4 4.789C4.035 3.756 4.751 3 6.057 3c1.204 0 2.008.694 2.008 1.661 0 .673-.334 1.143-.932 1.499-.575.334-.738.562-.738 1.002v.255h-1.02l-.004-.313c-.04-.65.215-1.045.822-1.401.545-.33.73-.567.73-1.002 0-.466-.37-.805-.923-.805-.567 0-.932.348-.967.893zm1.898 4.693a.63.63 0 0 1-.641-.624c0-.347.285-.62.641-.62s.638.273.638.62a.627.627 0 0 1-.638.624"
  })));
};
export default SvgQuestionIcon;